
export const currentPlan = {
  name: "Growth Annual",
  purchasedDate: "Jun 6, 2026",
  validUntil: "Jun 6, 2027",
  priceCurrency: "₦",
  priceValue: "280,000",
  sidebarPriceLabel: "₦280,000 / year · paid once",
  periodLabel: "per year · one payment",
  topUpRate: "₦2,000/credit",
  creditsLeft: 132,
  creditsTotal: 210,
  creditsPlan: 180,
  creditsTopUp: 30,
  progressPct: 63,
};

// ── Annual credit plans (4-column pricing grid) ──
export const annualPlans = [
  {
    id: "starter",
    tierLabel: "STARTER",
    name: "Starter",
    priceCurrency: "₦",
    priceValue: "120,000",
    pricePeriod: "/yr",
    tagline: { type: "chip", text: "60 credits upfront" },
    features: [
      "₦2,000 per credit effective",
      "2 active job posts",
      "AI matching & job post creation",
      "Top 5 candidate shortlist",
      "Email support",
      "Top-up rate ₦2,500/credit",
    ],
    cta: {
      label: "Available at renewal",
      variant: "default",
      toastMessage:
        "Downgrades apply at renewal — your Growth plan runs its full term.",
    },
  },
  {
    id: "growth",
    featured: true,
    topBadge: "YOUR PLAN",
    tierLabel: "GROWTH",
    name: "Growth",
    priceCurrency: "₦",
    priceValue: "280,000",
    pricePeriod: "/yr",
    tagline: { type: "chip", text: "180 credits upfront" },
    features: [
      "₦1,556 per credit effective",
      "5 active job posts",
      "Team collaboration (3 seats)",
      "Advanced analytics dashboard",
      "Priority support",
      "Top-up rate ₦2,000/credit",
    ],
    cta: { label: "Subscribed · until Jun 6, 2027", variant: "subscribed" },
  },
  {
    id: "scale",
    inlineTag: "BEST VALUE",
    tierLabel: "SCALE",
    name: "Scale",
    priceCurrency: "₦",
    priceValue: "650,000",
    pricePeriod: "/yr",
    tagline: { type: "chip", text: "480 credits upfront" },
    features: [
      "₦1,354 per credit effective",
      "Unlimited active job posts",
      "Team collaboration (10 seats)",
      "Dedicated success manager",
      "Full API access",
      "Top-up rate ₦1,700/credit",
    ],
    cta: {
      label: "Upgrade to Scale",
      variant: "default",
      toastMessage: "Upgrading to Scale — ₦650,000/yr, 480 credits upfront…",
    },
  },
  {
    id: "enterprise",
    tierLabel: "ENTERPRISE",
    tierLabelColor: "#7c3aed",
    name: "Enterprise",
    customPrice: "Custom",
    tagline: { type: "text", text: "Negotiated credits & validity" },
    features: [
      "Custom credit volume & validity",
      "Unlimited team seats",
      "HRIS & ATS integrations",
      "Multi-client subscriptions (coming soon)",
      "White-glove onboarding",
    ],
    cta: {
      label: "Contact Sales",
      variant: "default",
      toastMessage: "Connecting you with our sales team…",
    },
  },
];

// ── Top-up credit packs (3-column pricing grid) ──
export const topUpPacks = [
  {
    id: "starter-pack",
    tierLabel: "STARTER PACK",
    tierLabelColor: "#10b981",
    name: "10 credits",
    priceCurrency: "₦",
    priceValue: "35,000",
    tagline: { type: "text", text: "₦3,500 per credit · one-time" },
    features: [
      "Good for 1–2 hires",
      "Credits added instantly",
      "Roll over — never lost",
    ],
    cta: {
      label: "Buy Starter Pack",
      variant: "default",
      toastMessage: "Buying Starter Pack (10C) — ₦35,000…",
    },
  },
  {
    id: "growth-pack",
    inlineTag: "POPULAR",
    tierLabel: "GROWTH PACK",
    tierLabelColor: "#10b981",
    name: "30 credits",
    priceCurrency: "₦",
    priceValue: "90,000",
    tagline: { type: "text", text: "₦3,000 per credit · one-time" },
    features: [
      "Good for 4–6 hires",
      "Credits added instantly",
      "Roll over — never lost",
    ],
    cta: {
      label: "Buy Growth Pack",
      variant: "default",
      toastMessage: "Buying Growth Pack (30C) — ₦90,000…",
    },
  },
  {
    id: "scale-pack",
    tierLabel: "SCALE PACK",
    tierLabelColor: "#10b981",
    name: "75 credits",
    priceCurrency: "₦",
    priceValue: "200,000",
    tagline: { type: "text", text: "₦2,667 per credit · one-time" },
    features: [
      "Good for 10–15 hires",
      "Credits added instantly",
      "Roll over — never lost",
    ],
    cta: {
      label: "Buy Scale Pack",
      variant: "default",
      toastMessage: "Buying Scale Pack (75C) — ₦200,000…",
    },
  },
];

// ── Policy strip (4 static items) ──
export const policyItems = [
  {
    iconColor: "#10b981",
    title: "30-Day Rematch Guarantee",
    text: "If a hire leaves within 30 days, we rematch at 50% of the original credit cost.",
  },
  {
    iconColor: "#7c3aed",
    title: "Credits Never Lost",
    text: "Unused credits roll over indefinitely. If your plan lapses they're frozen — not lost — and unlock on reactivation.",
  },
  {
    iconColor: "#1d4ed8",
    title: "1-Year Validity",
    text: "Every plan grants 12 months of access from purchase. A new purchase resets the clock — it doesn't stack.",
  },
  {
    iconColor: "#d97706",
    title: "Upgrade Anytime",
    text: "Upgrade whenever you like. Downgrades apply at renewal — plans run their full term.",
  },
];

// ── Payment history (2 pages, ported verbatim from `historyPages`) ──
export const historyPages = {
  1: [
    {
      date: "Jun 28th, 2026",
      plan: "pack",
      planLabel: "Growth Pack",
      amount: "₦90,000",
      status: "completed",
    },
    {
      date: "Jun 6th, 2026",
      plan: "growth",
      planLabel: "Growth Annual",
      amount: "₦280,000",
      status: "completed",
    },
    {
      date: "Jun 5th, 2025",
      plan: "starter",
      planLabel: "Starter Annual",
      amount: "₦120,000",
      status: "completed",
    },
    {
      date: "Apr 12th, 2025",
      plan: "pack",
      planLabel: "Growth Pack",
      amount: "₦90,000",
      status: "completed",
    },
    {
      date: "Feb 3rd, 2025",
      plan: "pack",
      planLabel: "Starter Pack",
      amount: "₦35,000",
      status: "completed",
    },
    {
      date: "Jan 10th, 2025",
      plan: "pack",
      planLabel: "Starter Pack",
      amount: "₦35,000",
      status: "completed",
    },
  ],
  2: [
    {
      date: "Nov 23rd, 2024",
      plan: "pack",
      planLabel: "Growth Pack",
      amount: "₦90,000",
      status: "completed",
    },
    {
      date: "Sep 28th, 2024",
      plan: "pack",
      planLabel: "Starter Pack",
      amount: "₦35,000",
      status: "completed",
    },
    {
      date: "Aug 18th, 2024",
      plan: "pack",
      planLabel: "Starter Pack",
      amount: "₦35,000",
      status: "completed",
    },
  ],
};

export const TOTAL_HISTORY_PAGES = 2;

export const initialBillingInfo = {
  company: "Awasource Ltd",
  billingEmail: "awasource1@gmail.com",
  address: "Lagos, Nigeria",
};
